import { ReportsListingFilters } from '../types';

export function collectReportFilters(filters: ReportsListingFilters) {
  return {
    created: {
      to: filters.to.toISOString(),
      from: filters.from.toISOString(),
    },
    ...(filters.search ? { search: filters.search } : {}),
    ...(filters.stageId ? { stageId: filters.stageId } : {}),
    ...(filters.locationId ? { locationId: filters.locationId } : {}),
    ...(filters.departmentId ? { departmentId: filters.departmentId } : {}),
    ...(filters.salesPersonId ? { salesPersonId: filters.salesPersonId } : {}),
  };
}
